import React, { useEffect } from "react";
import "./aboutUs.scss";
import brandStore from "../../store/brandStore";
import { Stack } from "@mui/material";
import SEO from "components/seo/SEO";

const AboutUs = () => {
  const BrandStore = brandStore();

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div className="about-us">
      <SEO
        title="About Us | KRISTIVE"
        description="Learn about KRISTIVE's story, our passion for perfumery, and what makes our collection special. Discover the art and craft behind every fragrance."
      />
      <div className="title">Welcome to {BrandStore.brand.brandName}</div>
      <div className="content-about-us">
        <Stack spacing={2}>
          <div>
            At KRISTIVE, we believe fragrance is more than just a scent it’s a
            feeling, a memory, and a way to express who you are.
          </div>
          <div>
            We create fragrances for people who want to make an impression,
            whether it’s subtle and sophisticated, fresh and effortless, or bold
            and unforgettable. Each KRISTIVE fragrance is thoughtfully created
            with a focus on quality, character, and lasting appeal.
          </div>
          <div>
            KRISTIVE started with a simple idea:{" "}
            <b>
              to create unique, high-quality fragrances that people can truly
              connect with.
            </b>
          </div>
          <div>
            We don’t simply curate or resell scents. We create our own
            fragrances, carefully developing each scent with thoughtfully
            selected notes and a distinct character. From the first spray to the
            final dry-down, every fragrance is created to become a part of your
            personal story.
          </div>
          <div>
            Our collection is currently made up of a carefully selected range of
            fragrances, with each one created to offer a different mood,
            personality, and experience. And this is just the beginning.
          </div>
          <div>
            As KRISTIVE grows, we’re continuously exploring new ideas,
            experimenting with new notes, and creating more fragrances to expand
            our collection. Our goal is to build a diverse range of scents so
            that, over time, there’s something for every personality, occasion,
            and moment.
          </div>
        </Stack>
      </div>

      <div className="title" style={{ marginTop: "20px" }}>
        Made to Be Yours
      </div>

      <div className="content-about-us">
        <Stack spacing={2}>
          <div>
            We believe your fragrance should feel personal. It should reflect
            your style, your mood, and the impression you want to leave behind.
          </div>
          <div>
            That’s why we’re committed to creating fragrances with character,
            quality, and individuality while continuing to grow and evolve our
            collection.
          </div>
          <div>
            <b>KRISTIVE — Create your impression.</b>
          </div>
        </Stack>
        {/* <div className="contact-me-on-mail">
          If you can't find something here you can always <b>Mail</b> us on{" "}
          <b>{BrandStore.brand.brandEmail}</b> for customizations.
        </div> */}
      </div>
    </div>
  );
};

export default AboutUs;
